import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDemandMaterialSelectList } from '../api/index.js';
import { getMaterialLayoutSelect } from '@/views/manageCenter/api/index.js';
import { getconfigCardType } from '@/api/order';
import { getCityMateriaBranchList } from '@/api/manageCenter';
export default {
  name: 'CardDemandMaterialSelectDrawer',
  props: {
    // 父组件明细中已存在的卡券物料类型（material_type 1/2），用于重复拦截
    existingCardCouponTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 领卡需求登记场景传 '1'，控制接口查询可售可见物料
    isSaleVisible: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        is_sale_visible: this.isSaleVisible,
        material_id: '',
        name: '',
        material_type: [],
        print_type: '1',
        card_bin_group_id: '',
        card_type_id: '',
        layout_id: [],
        have_stock_count: '1',
        branch_office_id: [],
        sort: '',
        page: 1,
        pagesize: 20
      },
      // 卡券物料 + 其他物料
      materialTypeList: [{
        value: '1',
        label: 'PVC卡'
      }, {
        value: '2',
        label: '券'
      }, {
        value: '3',
        label: '卡套'
      }, {
        value: '4',
        label: '券套'
      }, {
        value: '5',
        label: '手提袋'
      }, {
        value: '6',
        label: '宣传册'
      }, {
        value: '7',
        label: '画册'
      }],
      cardTypeList: [],
      // 卡类型下拉（按业务类型联动）
      layoutList: [],
      // 版面下拉
      dataList: [],
      pages: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      },
      selection: [],
      branchCompanyList: []
    };
  },
  computed: {
    cardTypeChannelList: function cardTypeChannelList() {
      return this.$store.state.user.cardTypeChannelList;
    }
  },
  created: function created() {
    this.getList();
    this.getLayoutList();
    this.getBranchCompany();
  },
  methods: {
    getBranchCompany: function getBranchCompany() {
      var _this = this;
      getCityMateriaBranchList().then(function (res) {
        _this.branchCompanyList = res.data.list || [];
      });
    },
    getList: function getList() {
      var _this2 = this;
      getDemandMaterialSelectList(this.form).then(function (res) {
        _this2.dataList = res.data.list;
        _this2.pages = res.pages || {};
      });
    },
    // 获取版面下拉列表
    getLayoutList: function getLayoutList() {
      var _this3 = this;
      getMaterialLayoutSelect().then(function (res) {
        _this3.layoutList = res.data && res.data.list || [];
      });
    },
    // 根据业务类型获取卡类型
    getCardTypeList: function getCardTypeList(businessId) {
      var _this4 = this;
      getconfigCardType({
        business_id: businessId,
        version: 2,
        create_order: 1
      }).then(function (res) {
        _this4.cardTypeList = res.data;
      });
    },
    // 切换业务类型，联动清空卡类型
    changeCardBinId: function changeCardBinId(val) {
      this.form.card_type_id = [];
      this.cardTypeList = [];
      if (val) {
        this.getCardTypeList(val);
      }
    },
    search: function search() {
      this.form.page = 1;
      this.getList();
    },
    reset: function reset() {
      this.$refs.form.resetFields();
      this.form.material_type = [];
      this.form.card_type_id = [];
      this.form.layout_id = [];
      this.cardTypeList = [];
      this.search();
    },
    sortChange: function sortChange(_ref) {
      var column = _ref.column,
        prop = _ref.prop,
        order = _ref.order;
      if (!order) {
        this.form.sort = '';
      } else {
        this.form.sort = "".concat(order === 'ascending' ? '' : '-').concat(prop);
      }
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selection = val;
    },
    handleConfirm: function handleConfirm() {
      if (!this.selection.length) {
        this.$message.warning('请至少选择一个物料');
        return;
      }
      // 卡券物料（PVC卡/券）校验，参考制卡印刷单
      var newCardCoupon = this.selection.filter(function (item) {
        return String(item.material_type) === '1' || String(item.material_type) === '2';
      });
      if (newCardCoupon.length > 1) {
        this.$message.warning('只能选择1个卡/券类型的物料');
        return;
      }
      if (newCardCoupon.length === 1 && this.existingCardCouponTypes.length > 0) {
        this.$message.warning("\u5DF2\u5B58\u5728".concat(this.existingCardCouponTypes.map(function (t) {
          return String(t) === '1' ? 'PVC卡' : '券';
        }).join('、'), ",\u4E0D\u53EF\u91CD\u590D\u6DFB\u52A0"));
        return;
      }
      this.$emit('selected', this.selection);
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    },
    sizeChange: function sizeChange(val) {
      this.form.pagesize = val;
      this.form.page = 1;
      this.getList();
    }
  }
};